import { WorkflowListing } from "./components/WorkFlowListing/WorkflowListing";
/* eslint-disable-next-line */
export interface WorkflowManagementProps {}

export function WorkflowManagement() {
  return <WorkflowListing />;
}

export default WorkflowManagement;
